
import _ from 'lodash';
import { Sightseeing } from '../types/sightseeing';

const sightseeing: Sightseeing[] = [
    {
        "prefecture": 16,
        "title": "富山城",
        "geometry": {
            "type": "Point",
            "coordinates": [
                137.21162552547207,
                36.69288963664408, 
            ]
        },
        "description": "続日本100名城にも選ばれた富山城。季節ごとの自然豊かな富山城址公園内にあり、城址ならではのお堀や石垣に歴史を感じる見ごたえのあるお城です。",
        "image": "Toyama-main",
        "url": "https://www.toyamashi-kankoukyoukai.jp/?tid=100434",
    },
    {
        "prefecture": 16,
        "title": "富岩運河環水公園",
        "geometry": {
            "type": "Point",
            "coordinates": [
                137.21305236862105,
                36.709580189143594, 
            ]
        },
        "description": "富岩運河を囲むように広がる富岩運河環水公園は、富山駅から歩いて約9分。街なかの緑美しい水辺空間です。水と緑が豊かな公園内には魅力的なスポットがたくさん。",
        "image": "Toyama-kansui",
        "url": "https://www.kansui-park.jp/",
    },
    {
        "prefecture": 16,
        "title": "富山市ガラス美術館",
        "geometry": {
            "type": "Point",
            "coordinates": [
                137.21516716829007,
                36.68847471587042, 
            ]
        },
        "description": "「ガラスの街とやま」。富山市は、ガラス作家を育成する富山ガラス造形研究所や作家の制作活動を支援する富山ガラス工房、そして芸術鑑賞の場である富山市ガラス美術館が揃う、世界でも有数のガラスの街です。",
        "image": "Toyama-garasu",
        "url": "https://toyama-glass-art-museum.jp/",
    },
    {
        "prefecture": 16,
        "title": "黒部峡谷トロッコ電車",
        "geometry": {
            "type": "Point",
            "coordinates": [
                137.58598610424286,
                36.8150562536947, 
            ]
        },
        "description": "窓のない開放感たっぷりのトロッコやゆったりできる窓付き車両で、心地よい揺れを楽しみながら黒部峡谷を巡ります。車窓には宇奈月湖にかかる真紅の湖面橋や黒薙川（くろなぎがわ）にかかる高さ60mの後曳（あとびき）橋、紅葉名所の錦繍関（きんしゅうかん）など、見どころが次々と現れます。",
        "image": "Toyama-kurobe",
        "url": "https://www.kurotetu.co.jp/",
    },
    {
        "prefecture": 16,
        "title": "富山県美術館",
        "geometry": {
            "type": "Point",
            "coordinates": [
                137.2128737511729,
                36.711260485028156, 
            ]
        },
        "description": "富山県の木材やアルミを贅沢に使用して造られたガラス張りの外観。日本を代表する建築家、内藤廣氏設計の美しい美術館です。富岩運河環水公園内にあり、公園から富山県美術館に続く川沿いの道は美術館へのプロムナード。美しい風景を見ながらアートを楽しめます。",
        "image": "Toyama-bizyutsu",
        "url": "https://tad-toyama.jp/",
    },
]

/**
 * 観光を返す
 * @returns 
 */
const getSightseeing = (prefecture: number): Sightseeing[] => {
    return _.filter(sightseeing, (ss: Sightseeing) => ss.prefecture === prefecture);
}

export default getSightseeing;